// import { pathObj } from "@/services/apiPath";
import { pathObj } from "../../services/apiPath";
import { apiDelete, apiGet, apiPost, apiPut } from "../../services/httpServices";

const addBioDataApi = async (formData, notification, callback) => {
  callback?.(true, true);
  try {
    const response = await apiPost(
      pathObj.ADD_BIO_DATA,
      formData,
      "multipart/form-data"
    );
    if (response?.data?.success) {
      notification.success(response?.data?.message);
      callback?.(false, false);
    } else {
      callback?.(false, true);
      notification.error(response.data.message);
      console.error("Something went wrong");
    }
  } catch (error) {
    callback?.(false, true);
    console.error(error);
  }
};

const editBioDataApi = async (id, formData, notification, callback) => {
  callback?.(true, true);
  try {
    const response = await apiPut(
      pathObj.MARITAL_LIST + "/" + id,
      formData,
      "multipart/form-data"
    );
    if (response?.data?.success) {
      notification.success(response?.data?.message);
      callback?.(false, false);
    } else {
      callback?.(false, true);
      notification.error(response.data.message);
      console.error("Something went wrong");
    }
  } catch (error) {
    callback?.(false, true);
    console.error(error);
  }
};

const getMaritalApi = async (data, notification, callback) => {
  callback?.(true, true, {});
  try {
    const response = await apiGet(pathObj.MARITAL_LIST, data);

    if (response?.data?.success) {
      setTimeout(() => {
        callback?.(false, false, response?.data?.results);
      }, 2000);
    } else {
      callback?.(false, true, {});
      notification.error(response?.data?.message);
    }
  } catch (error) {
    callback?.(false, true, {});
    notification.error(
      error.message || "An error occurred while get the profile"
    );
    console.error(error);
  }
};

const getMaritalByIdApi = async (data, notification, callback) => {
  callback?.(true, true, {});
  const id = data.id
  delete data.id
  try {
    const response = await apiGet(`${pathObj.MARITAL_LIST}/${id}`, data);

    if (response?.data?.success) {
      setTimeout(() => {
        callback?.(false, false, response?.data?.results);
      }, 2000);
    } else {
      callback?.(false, true, {});
      notification.error(response?.data?.message);
    }
  } catch (error) {
    callback?.(false, true, {});
    notification.error(
      error.message || "An error occurred while get the profile"
    );
    console.error(error);
  }
};

const deleteMatrimonialApi = async (userData, notification, callback) => {
  callback?.(true, true);
  try {
    const response = await apiDelete(`${pathObj.MARITAL_LIST}/${userData?.id}`);

    const { success, message } = response?.data || {};

    if (success) {
      notification.success(message);
      callback?.(false, false);
    } else {
      callback?.(false, true);
      notification.error(message || "Delete user failed");
    }
  } catch (error) {
    callback?.(false, true); // Error state
    const errorMessage =
      error.message || "An error occurred while updating the profile.";
    notification.error(errorMessage);
    console.error(error);
  }
};

export { addBioDataApi, getMaritalApi, getMaritalByIdApi, editBioDataApi, deleteMatrimonialApi };
